var _ellipse, _path;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgUsdt(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 21,
    height: 21,
    viewBox: "0 0 21 21",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _ellipse || (_ellipse = /*#__PURE__*/React.createElement("ellipse", {
    cx: 10.5,
    cy: 10.5,
    rx: 10.5,
    ry: 10.5,
    fill: "#26A17B"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M12.0584 8.74306V7.12733H15.7204V4.66748H5.75072V7.12733H9.41274V8.74306C6.43828 8.88173 4.19922 9.47558 4.19922 10.187C4.19922 10.8984 6.43828 11.4923 9.41274 11.6309V16.8008H12.0613V11.6309C15.0328 11.4923 17.2659 10.8984 17.2659 10.187C17.2629 9.47558 15.0298 8.88173 12.0584 8.74306ZM12.0613 11.1938L12.0246 11.1956H12.0237C11.8935 11.202 11.5067 11.221 10.749 11.221C10.0644 11.221 9.58612 11.2029 9.41572 11.1938V11.1969C6.78805 11.0793 4.82401 10.6181 4.82401 10.0665C4.82401 9.51478 6.78505 9.05359 9.41572 8.93599V10.7327C9.58911 10.7447 10.0794 10.7748 10.7609 10.7748C11.5771 10.7748 11.9866 10.7417 12.0643 10.7327V8.92999C14.689 9.04754 16.6471 9.50878 16.6471 10.0604C16.6411 10.612 14.683 11.0733 12.0613 11.1938Z",
    fill: "white"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgUsdt);
export default __webpack_public_path__ + "static/media/usdt.2b665619.svg";
export { ForwardRef as ReactComponent };